import { getToken } from '../common/lib/token';
import config from '../config';

const WS_OPEN = 'WS_OPEN';
const WS_CLOSE = 'WS_CLOSE';
const WS_ERROR = 'WS_ERROR';

export const WS_EVENT_NEW = 'WS_EVENT_NEW';
export const WS_EVENT_STATUS = 'WS_EVENT_STATUS';

const WS = {
  // scope
  events: {
    // action
    created_new_event: WS_EVENT_NEW,
    updated_event_status: WS_EVENT_STATUS,
  },

  // socket: {
  //   ping: 'WS_PING',
  // },
};


let socket = null;

export const start = (dispatch) => {
  const token = getToken() || '';
  if (!token) return;

  socket = new WebSocket(`${config.wsUrl}?token=${token}`);
  if (socket) {
    socket.onopen = () => dispatch({ type: WS_OPEN });
    socket.onclose = event => dispatch({ type: WS_CLOSE, payload: event });
    socket.onerror = error => dispatch({ type: WS_ERROR, payload: error });
    socket.onmessage = (event) => {
      if (event.data) {
        const { scope, action, payload } = JSON.parse(event.data);
        if (WS[scope] && WS[scope][action]) {
          dispatch({ type: WS[scope][action], payload });
        }
      }
    };
  }
};

export const stop = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};

export const emit = (type, payload) => {
  console.log('WS emit: ', type, ' ', payload, ' ', socket);
  if (socket) {
    socket.send(type, payload);
  }
};
